import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService } from 'ngx-bootstrap/modal'
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { QuestionnaireComponent } from './questionnaire.component';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import { CreateQuestionnaireComponent } from './components/create-questionnaire/create-questionnaire.component';
import { EditQuestionnaireTitleModalComponent } from './components/edit-questionnaire-name/edit-questionnaire-title-modal.component';
import { SelectMetricsModalComponent } from './components/select-metrics-modal/select-metrics-modal.component';
import { BlankQuestionnaireComponent } from './components/blank-questionnaire/blank-questionnaire.component';
import { AddQuestionModalModule } from 'src/app/components/add-question-modal/add-question-modal.module';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { SelectSurveyComponent } from './components/select-survey/select-survey.component';
import { SelectSurveyModalComponent } from './components/select-survey-modal/select-survey-modal.component';
import { SurveyBuilderHelpModalModule } from 'src/app/components/survey-builder-help-modal/survey-builder-help-modal.module';
import { CreateCustomQuestionModule } from 'src/app/components/create-custom-question/create-custom-question.module';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { SurveyBlocksComponent } from './components/survey-blocks/survey-blocks.component';
import { LoaderModule } from 'src/app/components/loader/loader.module';
import {ButtonModule, ToggleModule} from '@xref/xref-lib';
import { TagsModule } from '@xref/xref-lib';
import { BannerModule } from '@xref/xref-lib';
import { TooltipModule as XrefTooltipModule } from '@xref/xref-lib';

@NgModule({
    declarations: [
        QuestionnaireComponent,
        CreateQuestionnaireComponent,
        EditQuestionnaireTitleModalComponent,
        SelectMetricsModalComponent,
        BlankQuestionnaireComponent,
        SelectSurveyComponent,
        SelectSurveyModalComponent,
        SurveyBlocksComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        AlertModule,
        DragDropModule,
        NgbModule,
        TooltipModule.forRoot(),
        TooltipEllipsifyModule,
        AddQuestionModalModule,
        SurveyBuilderHelpModalModule,
        CreateCustomQuestionModule,
        FooterModule,
        LoaderModule,
        ButtonModule,
        XrefTooltipModule,
        TagsModule,
        BannerModule,
        ToggleModule
    ],
    providers: [
        BsModalService,
        QuestionnaireService,
    ],
    exports: [
        QuestionnaireComponent,
        CreateQuestionnaireComponent,
        EditQuestionnaireTitleModalComponent,
        SelectMetricsModalComponent,
        BlankQuestionnaireComponent,
        SelectSurveyComponent,
    ],
    bootstrap: [QuestionnaireComponent]
})
export class QuestionnaireModule { }
